/*
  product-gallery-dots.js
  Galeria mobile: imagem inteira (sem peek) + pontos de paginacao.
*/
(function () {
  var MQ = window.matchMedia('(max-width: 749px)');

  function build(gallery) {
    var list = gallery.querySelector('[data-product-media-list]');
    if (!list) return;

    var old = gallery.querySelector('.pg-dots');
    if (old) old.remove();

    var slides = list.querySelectorAll('.product__slide');
    if (!MQ.matches || slides.length < 2) return;

    var dots = document.createElement('div');
    dots.className = 'pg-dots';

    Array.prototype.forEach.call(slides, function (slide, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Bild ' + (i + 1));
      if (i === 0) b.classList.add('is-active');
      b.addEventListener('click', function () {
        list.scrollTo({ left: slide.offsetLeft - list.offsetLeft, behavior: 'smooth' });
      });
      dots.appendChild(b);
    });

    list.insertAdjacentElement('afterend', dots);

    var buttons = dots.querySelectorAll('button');
    function sync() {
      var w = slides[0].getBoundingClientRect().width || 1;
      var idx = Math.round(list.scrollLeft / w);
      if (idx < 0) idx = 0;
      if (idx > buttons.length - 1) idx = buttons.length - 1;
      Array.prototype.forEach.call(buttons, function (b, i) {
        b.classList.toggle('is-active', i === idx);
      });
    }

    var t;
    list.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(sync, 60);
    }, { passive: true });

    sync();
  }

  function init() {
    var galleries = document.querySelectorAll('product-images.product__images--mobile-slider');
    Array.prototype.forEach.call(galleries, build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(init, 200);
  });

  document.addEventListener('shopify:section:load', init);
})();
